module.exports = __webpack_public_path__ + "img/cwell6.bb75b6d8.jpg";